import { apiClient } from './apiClient';

/**
 * Per-post usage rows for the client usage table. One row per generated blog
 * post; cost is in CREDITS only (never a raw provider dollar cost), like the
 * rest of the client-facing usage surface.
 */
export interface UsagePiece {
  content_id: string | null;
  title: string;
  template: string | null;
  word_count: number | null;
  /** Generation invocations for this post in the cycle (proxy — no hard counter). */
  attempts: number;
  credits: number;
  wordpress_url: string | null;
  published: boolean;
  model: string | null;
  quality_score: number | null;
  date: string;
}

export interface UsagePieces {
  tenant_id: string;
  cycle: string;
  pieces: UsagePiece[];
  /** True when more posts existed than the row cap. */
  truncated: boolean;
}

/**
 * @param month optional cycle ("YYYY-MM"); omit for the current month.
 */
export async function getUsagePieces(
  tenantId: string,
  month?: string,
): Promise<UsagePieces> {
  const { data } = await apiClient.get<UsagePieces>('/usage/pieces', {
    params: { tenant_id: tenantId, ...(month ? { month } : {}) },
  });
  return {
    ...data,
    pieces: data.pieces ?? [],
    truncated: Boolean(data.truncated),
  };
}
